import { useEffect, useState } from "react";
import { useConfig } from "../../../../../../hooks/useConfig";
import { Property } from "../../../../../../contexts/properties/logic";

type PropertyOption = {
    value: string;
    label: string;
}

export type LineItemsReportState = {
    selectedProperties: PropertyOption[];
    availableProperties: PropertyOption[];
    currentProperty: Property | undefined;
}

export type UseItemsReport = LineItemsReportState & {
    selectedPropertyIds: string[];
    setSelectedProperties: (ids: string[]) => void;
}

export function useLineItemsReportState(): UseItemsReport {
    const config = useConfig();
    const [state, setState] = useState<LineItemsReportState>(
        {
            selectedProperties: [],
            availableProperties: [],
            currentProperty: undefined
        }
    );

    useEffect(
        () => {
            if (config.isReady && config.properties?.properties) {
                setState(prev => {
                    if (config.properties.properties) {
                        const currentProperty = config.properties.currentProperty;
                        if(currentProperty && currentProperty.isAcquisitionProperty) {
                            const availableProperties = [{
                                value: currentProperty.id,
                                label: currentProperty.name
                            }];
                            const selectedProperties = availableProperties.map(p => p);
                            const newState: LineItemsReportState = {
                                selectedProperties: selectedProperties,
                                availableProperties: availableProperties,
                                currentProperty: currentProperty
                            };
                            return newState;
                        } else {
                            const availableProperties = config.properties.properties.map(p => ({
                                value: p.id,
                                label: p.name
                            }));
                            const selectedProperties = availableProperties.map(p => p);
                            const newState: LineItemsReportState = {
                                selectedProperties: selectedProperties,
                                availableProperties: availableProperties,
                                currentProperty: config.properties.currentProperty
                            };

                            return newState;
                        }
                    }
                    else {
                        return prev;
                    }
                });
            }
        },
        [config.isReady, config.properties?.properties]
    );

    const setSelectedProperties = (ids: string[]) => {
        setState(prev => {
            const selectedProperties = prev.availableProperties.filter(p => ids.includes(p.value));
            return {
                ...prev,
                selectedProperties: selectedProperties
            };
        });
    };

    return {
        ...state,
        selectedPropertyIds: state.selectedProperties.map(p => p.value),
        setSelectedProperties: setSelectedProperties
    };
}